<!-- [ vi-tab ]    ||        [ vi-mainbet |  vi-sidebet ] | vi-confirm ] -->

<div class="bodyWrapper" >
    <app-loader></app-loader>
    <router-outlet></router-outlet>
</div>

